import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// https://react.semantic-ui.com/modules/popup
import { Popup } from 'semantic-ui-react';

@connect()
export default class TooltipMessage extends React.Component {
  render() {
    let finalClasses = '' + (this.props.classes || '');
    return (
      <Popup
        className={finalClasses}
        content={this.props.text}
        trigger={this.props.children}
        on={this.props.trigger}
        position={this.props.position}
      />
    );
  }
}

TooltipMessage.defaultProps = {
  trigger: 'hover', // by default, show on hover
};

TooltipMessage.propTypes = {
  classes: PropTypes.string, // css classes
  text: PropTypes.string.isRequired, // Simple text content for the popover.
  position: PropTypes.string, // Position for the popover. eg: 'top left'
  trigger: PropTypes.string, // Events triggering the popup. Values - hover, click, focus
};
